<div class="page-wrapper" [ngClass]="[theme === 'dark' ? 'dark' : '']">
    <div class="content">
      <div class="order-details">
        <div class="content p-0">
  
          <div class="page-header">
            <div class="page-title">
              <h4>PTL Order List</h4>
            </div>
            <div class="page-btn d-flex">
              <button class="btn btn-added" (click)="createPtlOrder('Add','','orders/pickup-request')">+ Pickup Request</button>
            </div>
          </div>
  
          <div class="card">
            <div class="card-body">
  
              <div class="table-top">
                <div class="search-set">
                  <app-filter
                    (filterChange)="onFilterChange($event)"
                    [orderNumber]="true"
                    [showDateFilter]="true"
                    [lrNumber]="false"
                    [orderType]="true"
                    [tmsOrderStatus]="true"
                    [DateofPlacement]="false"
                    [showCustomer]="true"
                    [showVendor]="false"
                    (resetFilters)="onResetFilters()">
                  </app-filter>
                </div>
              </div>
  
              <div class="card">
                <p-table
                  [value]="tableLists"
                  dataKey="id"
                  [first]="first"
                  [showCurrentPageReport]="true"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  [scrollable]="true"
                  [tableStyle]="{ width: '100%' }"
                  [resizableColumns]="true" columnResizeMode="expand" [responsiveLayout]="'scroll'">
  
                  <ng-template pTemplate="header">
                    <tr>
                      <th pResizableColumn pSortableColumn="docketNumber" (click)="sortColumn('docketNumber', direction == 'DESC' ? 'ASC' : 'DESC')">
                        Docket No. <p-sortIcon field="docketNumber"></p-sortIcon>
                      </th>
                      <th pResizableColumn>Customer</th>
                      <th pResizableColumn>Consignee</th>
                      <th pResizableColumn>Vendor</th>
                      <th pResizableColumn>Route</th>
                      <th pResizableColumn pSortableColumn="deliveryType" (click)="sortColumn('deliveryType', direction == 'DESC' ? 'ASC' : 'DESC')">
                        Delivery Type <p-sortIcon field="deliveryType"></p-sortIcon>
                      </th>
                      <th pResizableColumn pSortableColumn="orderCreatedBy" (click)="sortColumn('orderCreatedBy', direction == 'DESC' ? 'ASC' : 'DESC')">
                        Created By <p-sortIcon field="orderCreatedBy"></p-sortIcon>
                      </th>
                      <th pResizableColumn pSortableColumn="poNumber" (click)="sortColumn('poNumber', direction == 'DESC' ? 'ASC' : 'DESC')">
                        PO No. <p-sortIcon field="poNumber"></p-sortIcon>
                      </th>
                      <th pResizableColumn>Status</th>
                      <th pResizableColumn style="width: 320px;">Actions</th>
                    </tr>
                  </ng-template>
  
                  <ng-template pTemplate="body" let-item>
                    <tr>
                      <td>
                        <a class="active docket-link" (click)="openDetail(item)">{{ item?.docketNumber}}</a>
                      </td>
                      <td>{{ displayName(item, 'customerName', 'customerId') }}</td>
                      <td><span class="ptl-pill ptl-pill-neutral">{{ displayName(item, 'consigneeName', 'consigneeId') }}</span></td>
                      <td>{{ displayName(item, 'vendorName', 'vendorId') }}</td>
                      <td>{{ item?.route }}</td>
                      <td>
                        <span class="ptl-pill" [ngClass]="isAppointment(item) ? 'ptl-pill-blue' : 'ptl-pill-neutral'">
                          {{ item?.deliveryType ? item.deliveryType + (isAppointment(item) ? '' : ' Delivery') : '--' }}
                        </span>
                      </td>
                      <td>
                        <span class="ptl-pill" [ngClass]="isCustomerCreated(item) ? 'ptl-pill-outline' : 'ptl-pill-neutral'">
                          {{ item?.orderCreatedBy || '--' }}
                        </span>
                      </td>
                      <td><span class="po-mono">{{ item?.poNumber || '--' }}</span></td>
                      <td>
                        <span class="ptl-status-pill" [ngClass]="getStatusClass(item)">{{ getStatusLabel(item) }}</span>
                      </td>
                      <td class="action-table-data">
                        <div class="edit-delete-action ptl-actions">
                          <button type="button" class="btn btn-secondary" (click)="trackDocket(item)">
                            <i class="pi pi-map-marker"></i> Track
                          </button>
                          <button type="button" class="btn btn-secondary" (click)="openPod(item)">
                            <i class="pi pi-clipboard"></i> POD
                          </button>
                          <!-- <button type="button" class="btn btn-primary"
                                  *ngIf="getStatusKey(item) === 'PENDING_PICKUP'"
                                  [disabled]="sendingId === item?.id"
                                  (click)="sendToVendor(item)">
                            <i class="pi pi-send"></i> Send to Vendor
                          </button> -->
                          <!-- <button type="button" class="btn btn-primary"
                                  *ngIf="getStatusKey(item) === 'IN_TRANSIT'"
                                  [disabled]="sendingId === item?.id"
                                  (click)="sendToVendor(item)">
                            <i class="pi pi-send"></i> Send
                          </button> -->
                          <button type="button" class="btn btn-primary ptl-btn-icon" pTooltip="Edit"
                                  *ngIf="hasRole('ROLE_KAM')"
                                  (click)="editOrderRow(item)">
                            <i class="pi pi-pencil"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
  
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="10" style="color: red; padding: 30px;">Not found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
  
            </div>
  
            <app-pagination [totalCount]="totalCount" [pageSize]="pageSize" [currentPage]="currentPage"
              (pageChange)="paginate($event)"></app-pagination>
          </div>
  
        </div>
      </div>
    </div>
  </div>
  
  <!-- ═══════════════════════════════════════════════
       ORDER DETAIL DIALOG
  ════════════════════════════════════════════════ -->
  <p-dialog
    [(visible)]="showDetailDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '34vw' }"
    styleClass="ptl-detail-dialog"
    (onHide)="closeDetail()">
  
    <ng-template pTemplate="header">
      <div class="detail-header">
        <span class="detail-title">Order Detail —</span>
        <span class="po-mono">{{ selectedOrder?.docketNumber || '#' + selectedOrder?.id }}</span>
      </div>
    </ng-template>
  
    <div class="detail-body" *ngIf="selectedOrder">
      <span class="ptl-status-pill" [ngClass]="getStatusClass(selectedOrder)">{{ getStatusLabel(selectedOrder) }}</span>
  
      <div class="detail-row">
        <span class="detail-label">Customer</span>
        <span class="detail-value">{{ displayName(selectedOrder, 'customerName', 'customerId') }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Consignee</span>
        <span class="detail-value">{{ displayName(selectedOrder, 'consigneeName', 'consigneeId') }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Vendor</span>
        <span class="detail-value">{{ displayName(selectedOrder, 'vendorName', 'vendorId') }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Route</span>
        <span class="detail-value">{{ routeWithPin(selectedOrder) }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Pickup Address</span>
        <span class="detail-value">{{ selectedOrder?.fromAddress || '--' }}{{ selectedOrder?.fromPincode ? ' ' + selectedOrder.fromPincode : '' }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Delivery Address</span>
        <span class="detail-value">{{ selectedOrder?.toAddress || '--' }}{{ selectedOrder?.toPincode ? ' ' + selectedOrder.toPincode : '' }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Weight / Vol. Weight</span>
        <span class="detail-value">{{ selectedOrder?.weight ?? '--' }} kg / {{ selectedOrder?.volumetricWeight ?? '--' }} kg</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">No. of Boxes</span>
        <span class="detail-value">{{ selectedOrder?.boxes ?? '--' }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Delivery Type</span>
        <span class="detail-value">
          <span class="ptl-pill" [ngClass]="isAppointment(selectedOrder) ? 'ptl-pill-blue' : 'ptl-pill-neutral'">{{ selectedOrder?.deliveryType || '--' }}</span>
        </span>
      </div>
      <div class="detail-row" *ngIf="selectedOrder?.appointmentSlot">
        <span class="detail-label">Appointment Slot</span>
        <span class="detail-value">{{ selectedOrder?.appointmentSlot }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">PO Number</span>
        <span class="detail-value"><span class="po-mono">{{ selectedOrder?.poNumber || '--' }}</span></span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Created By</span>
        <span class="detail-value">{{ selectedOrder?.orderCreatedBy || '--' }}</span>
      </div>
      <div class="detail-row" *ngIf="selectedOrder?.remarks">
        <span class="detail-label">Remarks</span>
        <span class="detail-value">{{ selectedOrder?.remarks }}</span>
      </div>
    </div>
  
    <ng-template pTemplate="footer">
      <div class="detail-footer">
        <button type="button" class="btn btn-primary" (click)="openPod(selectedOrder)">
          <i class="pi pi-clipboard"></i> POD Audit
        </button>
        <button type="button" class="btn btn-primary" (click)="trackDocket(selectedOrder)">
          <i class="pi pi-map-marker"></i> Track Docket
        </button>
        <button type="button" class="btn btn-cancel" (click)="closeDetail()">Close</button>
      </div>
    </ng-template>
  </p-dialog>